import {
	message,
	Input,
	Table,
	Button,
	Modal,
	Checkbox,
	Space,
	Radio,
} from 'antd'
import { useState } from 'react'

import ConfirmExitModal from '@components/Modal/ConfirmExitModal/index'
import { calculateTotalWithKoef, calculateLineTotal, calculateMetrTotalWithKoef } from '@utils/calculations'
import { formatNumberWithSpaces, numberWithSpacesIntl } from '@utils/numberWithSpaces'
import renderServiceTypeSvg from '@utils/renderServiceTypeSvg'
import {
	calculateShtPrices,
	calculateKvmPrices,
	circleServiceQuantity,
	circleShapeQuantity,
	semiCircleShapeQuantity,
	shapeSidesQuantity,
} from '@utils/salesOrderCalculations'
import { toggleSelectedService } from '@utils/salesOrderToggleSelection'

const PARAMETR_IMAGE_STYLE = { width: '50px', height: '50px' }

const renderShapeImageCell = (record, t) => (
	<div className="flex flex-col items-center gap-2">
		<img src={record.image} alt="service" style={PARAMETR_IMAGE_STYLE} />
		{/* <span>{record.itemCode}</span> */}
		<span>
			{record.itemCode === 'Circle' || record.itemCode === 'SemiCircle'
				? t('mm')
				: t('mm')}
		</span>
	</div>
)

const renderSimpleImageCell = (record) => (
	<div className="flex flex-col items-center gap-2">
		<img src={record.image} alt="service" style={PARAMETR_IMAGE_STYLE} />
		<span>{record.itemName}</span>
	</div>
)

const ServiceSelectCheckbox = ({ checked, onChange, disabled }) => (
	<Checkbox
		checked={checked}
		disabled={disabled}
		onChange={onChange}
		onClick={(e) => {
			e.stopPropagation()
		}}
	/>
)

// Shablon figures are single-choice, so they get a radio instead of the
// checkbox the other service tables use.
const ServiceSelectRadio = ({ checked, onChange, disabled }) => (
	<Radio
		checked={checked}
		disabled={disabled}
		onChange={onChange}
		onClick={(e) => {
			e.stopPropagation()
		}}
	/>
)

const SERVICE_MODAL_TABS = [
	{ key: 'tab1', label: 'Kalit Xizmatlari' },
	{ key: 'tab2', label: 'Dumaloq Xizmatlari' },
	{ key: 'tab3', label: 'Rombik Shakllari' },
	{ key: 'tab4', label: 'Shablon Shakllari' },
	{ key: 'tab5', label: 'Kalit Shakllari' },
	{ key: 'tab6', label: 'Rombik Chizmalari' },
	{ key: 'tab7', label: 'Kalit Chizmalari' },
	{ key: 'tab8', label: 'Ortish(Отгрузка)' },
]

const ServiceModalTabButton = ({ isActive, marginLeft, onClick, children }) => (
	<button
		className={`${
			isActive ? 'text-blue-900 underline underline-offset-8' : ''
		} font-semibold ${marginLeft ? 'ml-3 ' : ''}`}
		onClick={onClick}
	>
		{children}
	</button>
)

const renderFormattedPriceCell = (text) => (
	<span>{text !== null ? numberWithSpacesIntl(text) : ''}</span>
)

const ServicesModal = ({
	t,
	open,
	currentRecord,
	selectedServices,
	setSelectedServices,
	tableData,
	setTableData,
	setIsModalOpen,
	packageServicesData,
	serviceItemsData,
	rombikItemsData,
	telefonItemsData,
	kalitShapedData,
}) => {
	const [activeTab, setActiveTab] = useState('tab1')
	const [isConfirmServiceModalVisible, setIsConfirmServiceModalVisible] =
		useState(false)
	const [inputValues, setInputValues] = useState({})
	const [inputParametrQuantity, setInputParametrQuantity] = useState({})

	const applyServiceQuantityChange = (record, inputQuantity) => {
		// Update only the service that matches the record's itemCode
		const updatedSelectedServices = selectedServices.map((service) =>
			service.itemCode === record.itemCode
				? {
						...service,
						quantity: inputQuantity,
					}
				: service,
		)

		setSelectedServices(updatedSelectedServices)

		// Update the tableData for the specific record
		const updatedData = tableData.map((row) => {
			if (row.key === record.key) {
				const selectedServicesTotal = updatedSelectedServices.reduce(
					(acc, service) => acc + service.price * (service.quantity || 0),
					0,
				)
				const koef = 1
				const totalWithKoef = calculateTotalWithKoef(
					row.width,
					row.height,
					inputQuantity,
					koef,
				)
				const lineTotal = calculateLineTotal(
					row.price,
					selectedServicesTotal,
					totalWithKoef,
				)

				return {
					...row,
					quantity: inputQuantity,
					lineTotal,
				}
			}
			return row
		})

		setTableData(updatedData)
	}

	const ParametrTypeRadioGroup = ({
		record,
		fieldName,
		priceLineField,
		logSelectedPriceLine,
	}) => (
		<Radio.Group
			value={
				selectedServices.find(
					(service) => service.itemCode === record.itemCode,
				)?.[fieldName] || ''
			}
			className="flex flex-col gap-3 min-w-[140px]"
			disabled={
				!selectedServices.some(
					(service) => service.itemCode === record.itemCode,
				)
			}
		>
			{record.priceLines
				?.map((item) => ({
					value: item[priceLineField],
					label: item[priceLineField],
					data: item,
				}))
				?.map((opt) => (
					<Radio
						key={opt.value}
						value={opt.value}
						onClick={(e) => {
							e.stopPropagation()
						}}
						onChange={(e) => {
							const index = selectedServices.findIndex(
								(service) => service.itemCode === record.itemCode,
							)

							const selectedPriceLine = record.priceLines.find(
								(service) =>
									service[priceLineField] === e.target.value,
							)

							if (logSelectedPriceLine) {
								console.log('selectedPriceLine', selectedPriceLine)
							}

							const updatedServices = [...selectedServices]
							updatedServices[index] = {
								...updatedServices[index],
								[fieldName]: e.target.value,
								price: selectedPriceLine?.u_Price,
								U_Elektr_rasxod: selectedPriceLine?.U_Elektr_rasxod,
								U_Stanok_rasxod: selectedPriceLine?.U_Stanok_rasxod,
							}
							setSelectedServices(updatedServices)
						}}
					>
						{opt.label}
					</Radio>
				))}
		</Radio.Group>
	)

	const columnsServices = [
		{
			title: '',
			dataIndex: 'svg',
			key: 'svg',

			render: (_, record) => {
				return renderServiceTypeSvg(record.u_ServiceType)
			},
		},
		{
			title: t('service'),
			dataIndex: 'itemName',
			key: 'itemName',
			render: (text, record) => (
				<span>
					<span className="font-bold">
						{record.u_Number ? `${record.u_Number} ` : ''}
					</span>
					{`${text}`}
				</span>
			),
		},

		{
			title: t('price'),
			dataIndex: 'price',
			key: 'price',
			render: renderFormattedPriceCell,
		},
		{
			title: t('measureUnit'),
			dataIndex: 'ugpName',
			key: 'ugpName',
			render: (text, record) => (
				<span>
					{text !== null
						? record.itemName.includes('GRAVIROVKA')
							? 'м'
							: text
						: ''}
				</span>
			),
		},
		{
			title: t('quantity'),
			dataIndex: 'quantity',
			key: 'quantity',
			width: 150,
			render: (_, record) =>
				record.ugpName === 'шт' ? (
					<Input
						value={
							selectedServices.find(
								(service) =>
									service.itemCode === record.itemCode,
							)?.quantity || ''
						}
						key={`${currentRecord.key}`}
						className={'w-full'}
						disabled={
							!selectedServices.some(
								(service) =>
									service.itemCode === record.itemCode,
							)
						}
						onChange={(e) => {
							applyServiceQuantityChange(record, e.target.value)
						}}
						onClick={(e) => {
							e.stopPropagation()
						}}
					/>
				) : (
					''
				),
		},
		{
			title: t('Select'),
			dataIndex: 'itemCode',
			key: 'select',
			render: (itemCode, record) => {
				const isChecked = selectedServices.some(
					(service) => service.itemCode === itemCode,
				)
				return (
					<ServiceSelectCheckbox
						checked={isChecked}
						onChange={() => {
							toggleServiceSelection(record.itemCode)
						}}
					/>
				)
			},
		},
	]

	const columnsOtgruzka = [
		{
			title: t('service'),
			dataIndex: 'itemName',
			key: 'itemName',
			render: (text, record) => (
				<span>
					<span className="font-bold">
						{record.u_Number ? `${record.u_Number} ` : ''}
					</span>
					{`${text}`}
				</span>
			),
		},

		{
			title: t('price'),
			dataIndex: 'price',
			key: 'price',
			render: renderFormattedPriceCell,
		},

		{
			title: t('Select'),
			dataIndex: 'itemCode',
			key: 'select',
			render: (itemCode, record) => {
				const isChecked = selectedServices.some(
					(service) => service.itemCode === itemCode,
				)
				return (
					<ServiceSelectCheckbox
						checked={isChecked}
						onChange={() => {
							toggleServiceSelection(record.itemCode)
						}}
					/>
				)
			},
		},
	]

	const columnsKalitParametrs = [
		{
			title: t('service'),
			dataIndex: 'image',
			key: 'image',
			render: (text, record) => renderShapeImageCell(record, t),
		},
		{
			title: t('itemName'),
			dataIndex: 'itemName',
			key: 'itemName',
		},
		{
			title: t('sizeType'),
			dataIndex: 'sizeType',
			key: 'sizeType',
			render: (text, record) => (
				<ParametrTypeRadioGroup
					record={record}
					fieldName="u_SizeType"
					priceLineField="u_SizeType"
					logSelectedPriceLine={false}
				/>
			),
		},
		{
			title: t('price'),
			dataIndex: 'price',
			key: 'price',
			render: (text, record) => {
				const parametrsInfo = selectedServices.find(
					(service) => service.itemCode === record.itemCode,
				)

				// console.log('parametrsInfo', parametrsInfo)

				return (
					<span>
						{parametrsInfo?.price
							? formatNumberWithSpaces(parametrsInfo.price)
							: ''}
					</span>
				)
			},
		},
		// {
		// 	title: t('size'),
		// 	dataIndex: 'itemCode',
		// 	key: 'inputs',
		// 	render: (itemCode, record) => {
		// 		const isSelected = selectedServices.some(
		// 			(service) => service.itemCode === record.itemCode,
		// 		)
		// 		return (
		// 			<div>
		// 				{renderInputs(
		// 					itemCode,
		// 					`${currentRecord.key}${itemCode}`,
		// 					isSelected,
		// 				)}
		// 			</div>
		// 		)
		// 	},
		// },
		{
			title: t('quantity'),
			dataIndex: 'itemCode',
			key: 'inputs',
			render: (itemCode, record) => {
				const isSelected = selectedServices.some(
					(service) => service.itemCode === record.itemCode,
				)
				return (
					<div>
						{renderInputsParametrQuantity(
							itemCode,
							`${currentRecord.key}${itemCode}`,
							isSelected,
						)}
					</div>
				)
			},
		},

		{
			title: t('Select'),
			dataIndex: 'itemCode',
			key: 'select',
			render: (itemCode, record) => (
				<ServiceSelectCheckbox
					checked={selectedServices.some(
						(service) => service.itemCode === itemCode,
					)}
					onChange={() => {
						toggleKalitParametrSelection(itemCode, record.key)
					}}
				/>
			),
		},
	]

	const columnsRombikParametrs = [
		{
			title: t('service'),
			dataIndex: 'image',
			key: 'image',
			render: (text, record) => renderShapeImageCell(record, t),
		},

		{
			title: t('itemName'),
			dataIndex: 'itemName',
			key: 'itemName',
		},
		{
			title: t('typeOfGrinding'),
			dataIndex: 'serviceType',
			key: 'serviceType',
			render: (text, record) => (
				<ParametrTypeRadioGroup
					record={record}
					fieldName="u_SharepeningType"
					priceLineField="u_ServiceType"
					logSelectedPriceLine={true}
				/>
			),
		},
		{
			title: t('price'),
			dataIndex: 'price',
			key: 'price',
			render: (text, record) => {
				const parametrsInfo = selectedServices.find(
					(service) => service.itemCode === record.itemCode,
				)

				// console.log('parametrsInfo', parametrsInfo)

				return (
					<span>
						{parametrsInfo?.price
							? formatNumberWithSpaces(parametrsInfo.price)
							: ''}
					</span>
				)
			},
		},
		{
			title: t('size'),
			dataIndex: 'itemCode',
			key: 'inputsSize',
			render: (itemCode, record) => {
				const isSelected = selectedServices.some(
					(service) => service.itemCode === record.itemCode,
				)
				return (
					<div>
						{renderInputs(
							itemCode,
							`${currentRecord.key}${itemCode}`,
							isSelected,
						)}
					</div>
				)
			},
		},
		{
			title: t('quantity'),
			dataIndex: 'itemCode',
			key: 'inputs',
			render: (itemCode, record) => {
				const isSelected = selectedServices.some(
					(service) => service.itemCode === record.itemCode,
				)
				return (
					<div>
						{renderInputsParametrQuantity(
							itemCode,
							`${currentRecord.key}${itemCode}`,
							isSelected,
						)}
					</div>
				)
			},
		},

		{
			title: t('Select'),
			dataIndex: 'itemCode',
			key: 'select',
			render: (itemCode, record) => (
				<ServiceSelectCheckbox
					checked={selectedServices.some(
						(service) => service.itemCode === itemCode,
					)}
					onChange={() => {
						toggleRombikParametrSelection(itemCode, record.key)
					}}
				/>
			),
		},
	]

	const columnsTelefonParametrs = [
		{
			title: t('service'),
			dataIndex: 'image',
			key: 'image',
			render: (text, record) => renderShapeImageCell(record, t),
		},

		{
			title: t('itemName'),
			dataIndex: 'itemName',
			key: 'itemName',
		},
		{
			title: t('typeOfGrinding'),
			dataIndex: 'serviceType',
			key: 'serviceType',
			render: (text, record) => (
				<ParametrTypeRadioGroup
					record={record}
					fieldName="u_SharepeningType"
					priceLineField="u_ServiceType"
					logSelectedPriceLine={true}
				/>
			),
		},
		{
			title: t('price'),
			dataIndex: 'price',
			key: 'price',
			render: (text, record) => {
				const parametrsInfo = selectedServices.find(
					(service) => service.itemCode === record.itemCode,
				)

				// console.log('parametrsInfo', parametrsInfo)

				return (
					<span>
						{parametrsInfo?.price
							? formatNumberWithSpaces(parametrsInfo.price)
							: ''}
					</span>
				)
			},
		},

		{
			title: t('quantity'),
			dataIndex: 'quantity',
			key: 'quantity',
			render: (itemCode, record) => {
				const quantity = selectedServices.find(
					(service) => service.itemCode === record.itemCode,
				)?.quantity
				return (
					<span>
						{quantity ? formatNumberWithSpaces(quantity) : ''}
					</span>
				)
			},
		},

		{
			title: t('Select'),
			dataIndex: 'itemCode',
			key: 'select',
			render: (itemCode, record) => (
				<ServiceSelectCheckbox
					checked={selectedServices.some(
						(service) => service.itemCode === itemCode,
					)}
					onChange={() => {
						toggleTelefonParametrSelection(itemCode, record.key)
					}}
				/>
			),
		},
	]

	const columnsShablonParametrs = [
		{
			title: t('chizma'),
			dataIndex: 'image',
			key: 'image',
			render: (text, record) => renderSimpleImageCell(record),
		},

		{
			title: t('Select'),
			dataIndex: 'itemCode',
			key: 'select',
			width: 150,
			render: (itemCode) => (
				<div className="text-center">
					<ServiceSelectRadio
						checked={selectedServices.some(
							(service) => service.itemCode === itemCode,
						)}
						onChange={() => {
							toggleShablonParametrSelection(itemCode)
						}}
						disabled={selectedServices.every(
							(service) => !service.isShablonService,
						)}
					/>
				</div>
			),
		},
	]

	const columnsShablonServices = [
		{
			title: t('service'),
			dataIndex: 'itemName',
			key: 'itemName',
			render: (text, record) => (
				<span>
					<span className="font-bold">
						{record.u_Number ? `${record.u_Number} ` : ''}
					</span>
					{`${text}`}
				</span>
			),
		},
		{
			title: t('price'),
			dataIndex: 'price',
			key: 'price',
			render: renderFormattedPriceCell,
		},
		{
			title: t('measureUnit'),
			dataIndex: 'ugpName',
			key: 'ugpName',
			render: (text) => <span>{text !== null ? text : ''}</span>,
		},
		{
			title: t('quantity'),
			dataIndex: 'quantity',
			key: 'quantity',
			width: 150,
			render: (_, record) => (
				// record.ugpName === 'шт' ? (
				<Input
					value={
						selectedServices.find(
							(service) => service.itemCode === record.itemCode,
						)?.quantity || ''
					}
					key={`${currentRecord.key}`}
					className={'w-full'}
					disabled={
						!selectedServices.some(
							(service) => service.itemCode === record.itemCode,
						)
					}
					onChange={(e) => {
						applyServiceQuantityChange(record, e.target.value)
					}}
					onClick={(e) => {
						e.stopPropagation()
					}}
				/>
			),
			// ) : (
			// 	''
			// ),
		},
		{
			title: t('Select'),
			dataIndex: 'itemCode',
			key: 'select',
			render: (itemCode, record) => {
				const isChecked = selectedServices.some(
					(service) => service.itemCode === itemCode,
				)
				return (
					<ServiceSelectCheckbox
						checked={isChecked}
						onChange={() => {
							toggleShablonServiceSelection(record.itemCode)
						}}
					/>
				)
			},
		},
	]

	const columnsItemsImages = [
		{
			title: t('chizma'),
			dataIndex: 'image',
			key: 'image',
			render: (text, record) => renderSimpleImageCell(record),
		},

		{
			title: t('Select'),
			dataIndex: 'itemCode',
			key: 'select',
			width: 150,
			render: (itemCode) => (
				<div className="text-center">
					<ServiceSelectCheckbox
						checked={selectedServices.some(
							(service) => service.itemCode === itemCode,
						)}
						onChange={() => {
							toggleItemsImagesSelection(itemCode)
						}}
					/>
				</div>
			),
		},
	]

	const renderInputs = (itemCode, rowKey, isSelected) => {
		let inputCount = 1
		if (
			itemCode === 'Rectangle' ||
			itemCode === 'Parallelogram' ||
			itemCode === 'Square' ||
			itemCode === 'Asal02' ||
			itemCode === 'Rhombus' ||
			itemCode === 'Trapezoid' ||
			itemCode === 'Archa01' ||
			itemCode === 'Archa02' ||
			itemCode === 'Archa' ||
			itemCode === 'Rectangle02' ||
			itemCode === 'Trapezoid' ||
			itemCode === 'Parallelogram' ||
			itemCode === 'Archa'
		) {
			inputCount = 4
		} else if (
			itemCode === 'Qalam01' ||
			itemCode === 'Qalam02' ||
			itemCode === 'Pentagon' ||
			itemCode === 'Asal01'
		) {
			inputCount = 5
		} else if (itemCode === 'Triangle' || itemCode === 'Triangle01') {
			inputCount = 3
		} else if (itemCode === 'Octagon' || itemCode === 'Qombik') {
			inputCount = 8
		} else if (itemCode === 'Triangle02') {
			inputCount = 3
		} else if (
			itemCode === 'Pencil' ||
			itemCode === 'Qalam' ||
			itemCode === 'Qombik1' ||
			itemCode === 'Qombik2' ||
			itemCode === 'Asal'
		) {
			inputCount = 6
		} else if (
			itemCode === 'SemiCircle' ||
			itemCode === 'Oval' ||
			itemCode === 'Oval01' ||
			itemCode === 'Oval02' ||
			itemCode === 'Circle' ||
			itemCode === 'MabelShablon9' ||
			itemCode === 'MebelShablon10' ||
			itemCode === 'TelefonBurchak1'
		) {
			inputCount = 1
		} else if (itemCode !== 'Circle') {
			inputCount = 1
			//Qolgan shakllarga bitta input bo'ladi
		}

		return Array.from({ length: inputCount }, (_, index) => (
			<Input
				key={`${rowKey}-input-${index}`}
				value={inputValues[rowKey]?.[index] || ''}
				onChange={(e) => {
					handleInputChange(rowKey, index, e.target.value)
				}}
				onClick={(e) => {
					e.stopPropagation()
				}}
				className="mb-2 w-full"
				disabled={!isSelected}
			/>
		))
	}

	const renderInputsParametrQuantity = (itemCode, rowKey, isSelected) => {
		const inputCount = 1
		return Array.from({ length: inputCount }, (_, index) => (
			<Input
				key={`${rowKey}-input-${index}`}
				value={inputParametrQuantity[rowKey]?.[index] || ''}
				onChange={(e) => {
					handleParametrQuantityInputChange(
						rowKey,
						index,
						e.target.value,
					)
				}}
				onClick={(e) => {
					e.stopPropagation()
				}}
				className="mb-2 w-[100px]"
				disabled={!isSelected}
			/>
		))
	}

	const handleInputChange = (rowKey, index, value) => {
		setInputValues((prev) => {
			const updatedValues = { ...prev }
			if (!updatedValues[rowKey]) {
				updatedValues[rowKey] = [] // Initialize row if not present
			}
			updatedValues[rowKey][index] = value // Set the specific input value
			return updatedValues
		})
	}

	const handleParametrQuantityInputChange = (rowKey, index, value) => {
		setInputParametrQuantity((prev) => {
			const updatedValues = { ...prev }
			if (!updatedValues[rowKey]) {
				updatedValues[rowKey] = [] // Initialize row if not present
			}
			updatedValues[rowKey][index] = value // Set the specific input value
			return updatedValues
		})
	}

	const toggleRombikParametrSelection = (itemCode) => {
		const selectedService = rombikItemsData.find(
			(service) => service.itemCode === itemCode,
		)

		if (selectedService && currentRecord) {
			setSelectedServices((prevSelected) =>
				toggleSelectedService(prevSelected, itemCode, () => {
					const {
						itemCode,
						itemName,
						ugpName,
						u_Timer,
						u_Number,
						priceLines,
						u_Modal,
						u_ProductionNumber,
					} = selectedService
					const { lineNum, currency, quantity, width, height } =
						currentRecord
					return {
						width,
						height,
						itemCode,
						itemName,
						price: priceLines.length > 0 ? priceLines[0].u_Price : -1,
						u_SharepeningType:
							priceLines.length > 0
								? priceLines[0].u_ServiceType
								: '',
						U_Elektr_rasxod:
							priceLines.length > 0
								? priceLines[0].U_Elektr_rasxod
								: -1,
						U_Stanok_rasxod:
							priceLines.length > 0
								? priceLines[0].U_Stanok_rasxod
								: -1,
						lineNum,
						currency,
						itemQuantity: quantity,
						ugpName,
						u_Timer,
						u_Number,
						u_Modal,
						u_ProductionNumber,

						isParametr: true,
						isRombikParametr: true,
					}
				}),
			)

			// setInputValues((prev) => {
			// 	const updatedValues = { ...prev }
			// 	if (!prev[rowKey]) {
			// 		updatedValues[rowKey] = Array(10).fill('')
			// 	}
			// 	if (
			// 		selectedServices.some(
			// 			(service) => service.itemCode === itemCode,
			// 		)
			// 	) {
			// 		return updatedValues[rowKey]
			// 	}
			// 	return updatedValues
			// })
		}
	}

	const toggleTelefonParametrSelection = (itemCode) => {
		const selectedService = telefonItemsData.find(
			(service) => service.itemCode === itemCode,
		)

		if (selectedService && currentRecord) {
			let parametrQuantity

			if (itemCode === 'TelefonBurchak') {
				parametrQuantity = 1
			}

			if (itemCode === 'TelefonBurchak 2') {
				parametrQuantity = 3
			}

			if (itemCode === 'TelefonBurchak1') {
				parametrQuantity = 2
			}

			if (itemCode === 'TelefonBurchak3') {
				parametrQuantity = 4
			}

			setSelectedServices((prevSelected) =>
				toggleSelectedService(prevSelected, itemCode, () => {
					const {
						itemCode,
						itemName,
						ugpName,
						u_Timer,
						u_Number,
						priceLines,
						u_Modal,
						u_ProductionNumber,
					} = selectedService
					const { lineNum, currency, quantity, width, height } =
						currentRecord
					return {
						width,
						height,
						itemCode,
						itemName,
						price: priceLines.length > 0 ? priceLines[0].u_Price : -1,
						u_SharepeningType:
							priceLines.length > 0
								? priceLines[0].u_ServiceType
								: '',
						U_Elektr_rasxod:
							priceLines.length > 0
								? priceLines[0].U_Elektr_rasxod
								: -1,
						U_Stanok_rasxod:
							priceLines.length > 0
								? priceLines[0].U_Stanok_rasxod
								: -1,
						lineNum,
						currency,
						itemQuantity: quantity,
						quantity: parametrQuantity,
						ugpName,
						u_Timer,
						u_Number,
						u_Modal,
						u_ProductionNumber,
					}
				}),
			)
		}
	}

	const toggleKalitParametrSelection = (itemCode) => {
		const selectedService = kalitShapedData.find(
			(service) => service.itemCode === itemCode,
		)

		if (selectedService && currentRecord) {
			setSelectedServices((prevSelected) =>
				toggleSelectedService(prevSelected, itemCode, () => {
					const {
						itemCode,
						itemName,
						ugpName,
						u_Timer,
						u_Number,
						priceLines,
						u_Modal,
						u_ProductionNumber,
					} = selectedService
					const { lineNum, currency, quantity, width, height } =
						currentRecord
					return {
						width,
						height,
						itemCode,
						itemName,
						price: priceLines.length > 0 ? priceLines[0].u_Price : -1,
						u_SizeType:
							priceLines.length > 0
								? priceLines[0].u_SizeType
								: '',
						U_Elektr_rasxod:
							priceLines.length > 0
								? priceLines[0].U_Elektr_rasxod
								: -1,
						U_Stanok_rasxod:
							priceLines.length > 0
								? priceLines[0].U_Stanok_rasxod
								: -1,
						lineNum,
						currency,
						itemQuantity: quantity,
						ugpName,
						u_Modal,
						u_Timer,
						u_Number,
						u_ProductionNumber,

						isParametr: true,
						isKalitParametr: true,
					}
				}),
			)

			// setInputValues((prev) => {
			// 	const updatedValues = { ...prev }
			// 	if (!prev[rowKey]) {
			// 		updatedValues[rowKey] = Array(10).fill('')
			// 	}
			// 	if (
			// 		selectedServices.some(
			// 			(service) => service.itemCode === itemCode,
			// 		)
			// 	) {
			// 		return updatedValues[rowKey]
			// 	}
			// 	return updatedValues
			// })
		}
	}

	const toggleServiceSelection = (itemCode) => {
		const selectedService = serviceItemsData.find(
			(service) => service.itemCode === itemCode,
		)
		if (selectedService && currentRecord) {
			setSelectedServices((prevSelected) =>
				toggleSelectedService(prevSelected, itemCode, () => {
					const {
						itemCode,
						itemName,
						price,
						ugpName,
						u_Timer,
						u_Number,
						u_ServiceType: uItemServiceType,
						u_Modal,
						u_ProductionNumber,
						U_Elektr_rasxod,
						U_Stanok_rasxod,
					} = selectedService
					const { lineNum, currency, quantity, width, height } =
						currentRecord
					return {
						width,
						height,
						itemCode,
						itemName,
						price,
						lineNum,
						currency,
						quantity: ugpName !== 'шт' ? quantity : '',
						itemQuantity: quantity,
						ugpName,
						u_Timer,
						u_Number,
						uItemServiceType,
						U_Elektr_rasxod,
						U_Stanok_rasxod,
						u_Modal,
						isParametr: false,
						isService: true,
						u_ProductionNumber,
					}
				}),
			)
		}
	}

	const toggleShablonServiceSelection = (itemCode) => {
		const selectedService = serviceItemsData.find(
			(service) => service.itemCode === itemCode,
		)

		if (selectedService && currentRecord) {
			setSelectedServices((prevSelected) =>
				toggleSelectedService(prevSelected, itemCode, () => {
					const {
						itemCode,
						itemName,
						price,
						ugpName,
						u_Timer,
						u_Number,
						u_Modal,
						u_ProductionNumber,
						U_Elektr_rasxod,
						U_Stanok_rasxod,
					} = selectedService
					const { lineNum, currency, quantity, width, height } =
						currentRecord
					return {
						width,
						height,
						itemCode,
						itemName,
						price,
						lineNum,
						currency,
						itemQuantity: quantity,
						U_Elektr_rasxod,
						U_Stanok_rasxod,
						ugpName,
						u_Timer,
						u_Number,
						u_Modal,
						isParametr: false,
						isShablonService: true,
						isService: true,
						u_ProductionNumber,
					}
				}),
			)
		}
	}

	const toggleItemsImagesSelection = (itemCode) => {
		const selectedService = serviceItemsData.find(
			(service) => service.itemCode === itemCode,
		)
		if (selectedService && currentRecord) {
			setSelectedServices((prevSelected) =>
				toggleSelectedService(prevSelected, itemCode, () => {
					const {
						itemCode,
						itemName,
						ugpName,
						u_Timer,
						u_Number,
						u_Modal,
						u_ProductionNumber,
						U_Elektr_rasxod,
						U_Stanok_rasxod,
					} = selectedService
					const { lineNum, currency } = currentRecord
					return {
						width: 0,
						height: 0,
						itemCode,
						itemName,
						price: 0,
						lineNum,
						currency,
						quantity: 0,
						ugpName,
						u_Timer,
						u_Number,
						u_Modal,
						isParametr: false,
						isChizma: true,
						u_ProductionNumber,
						U_Elektr_rasxod,
						U_Stanok_rasxod,
					}
				}),
			)
		}
	}

	const toggleShablonParametrSelection = (itemCode) => {
		if (selectedServices.every((service) => !service.isShablonService)) {
			return message.error('Сначала Выберите шаблонную услугу')
		}
		const selectedService = serviceItemsData.find(
			(service) => service.itemCode === itemCode,
		)

		const isAlreadySelected = selectedServices.some(
			(service) => service.itemCode === itemCode,
		)

		if (selectedService && currentRecord) {
			setSelectedServices((prevSelected) => {
				let newSelectedServices

				if (isAlreadySelected) {
					newSelectedServices = prevSelected.filter(
						(service) => service.itemCode !== itemCode,
					)
				} else {
					const {
						itemCode,
						itemName,
						ugpName,
						u_Timer,
						u_Number,
						u_Modal,
						u_ProductionNumber,
						U_Elektr_rasxod,
						U_Stanok_rasxod,
					} = selectedService
					const { lineNum, currency } = currentRecord
					newSelectedServices = [
						// Only one shablon figure may be selected, so drop any
						// previously chosen one instead of appending to it.
						...prevSelected.filter(
							(service) => !service.isShablonParametr,
						),
						{
							width: 0,
							height: 0,
							itemCode,
							itemName,
							price: 0,
							lineNum,
							currency,
							quantity: 0,
							ugpName,
							u_Timer,
							u_Number,
							u_Modal,
							isParametr: false,
							isChizma: false,
							isShablonParametr: true,
							u_ProductionNumber,
							U_Elektr_rasxod,
							U_Stanok_rasxod,
						},
					]
				}
				return newSelectedServices
			})
		}
	}

	const toggleServiceSelectionGroup = (line) => {
		const selectedService = line
			.map((item) =>
				serviceItemsData.find(
					(service) => service.itemCode === item.itemCode,
				),
			)
			.filter(Boolean) // Remove undefined values

		// Find itemCodes that do not exist
		const missingItemCodes = line
			.map((item) => item.itemCode)
			.filter(
				(itemCode) =>
					!serviceItemsData.some(
						(service) => service.itemCode === itemCode,
					),
			)

		// Show an error message for missing itemCodes
		if (missingItemCodes.length > 0) {
			message.error(
				`The following item codes were not found: ${missingItemCodes.join(', ')}`,
			)
		}

		if (selectedService.length > 0 && currentRecord) {
			setSelectedServices((prevSelected) => {
				const isAlreadySelected = line.every((item) =>
					prevSelected.some(
						(service) => service.itemCode === item.itemCode,
					),
				)

				let newSelectedServices

				if (isAlreadySelected) {
					newSelectedServices = prevSelected.filter(
						(service) =>
							!line.some(
								(item) => item.itemCode === service.itemCode,
							),
					)
				} else {
					const newServices = selectedService.map(
						({
							itemCode,
							price,
							ugpName,
							u_Timer,
							u_Number,
							u_Modal,
							u_ProductionNumber,
							U_Elektr_rasxod,
							U_Stanok_rasxod,
						}) => {
							const {
								lineNum,
								currency,
								quantity,
								width,
								height,
							} = currentRecord
							return {
								width,
								height,
								itemCode,
								price,
								lineNum,
								currency,
								quantity,
								ugpName,
								u_Modal,
								u_Timer,
								u_Number,
								u_ProductionNumber,
								isParametr: false,
								isService: true,
								U_Elektr_rasxod,
								U_Stanok_rasxod,
							}
						},
					)
					newSelectedServices = [...prevSelected, ...newServices]
				}
				return newSelectedServices
			})
		}
	}

	const handleOkCombined = () => {
		const hasShablonService = selectedServices.filter(
			(service) => service.isShablonService,
		)
		const hasShablonParametr = selectedServices.filter(
			(service) => service.isShablonParametr,
		)

		const isShanblonFullySelected =
			hasShablonService.length > 0 === hasShablonParametr.length > 0

		if (!isShanblonFullySelected) {
			message.error(
				'Если вы выбрали Шаблон услуги, то вы также должны выбрать Шаблон фигуры!',
			)
			return
		}
		const updatedSelectedServices = selectedServices.map((service) => {
			let quantity = service.quantity || 0
			let u_ParametrQuantityValues = service.u_ParametrQuantityValues || 0
			let isParametr = false
			// Calculate quantity for shapes if inputValues are present
			const inputValuesForRow =
				inputValues[`${currentRecord.key}${service.itemCode}`] || []

			console.log('service', service)

			if (
				service.u_Modal === 'Circle_Services' &&
				service.ugpName === 'м'
			) {
				quantity = circleServiceQuantity(service.width, service.itemQuantity)
			}

			if (inputValuesForRow.length > 0) {
				if (service.itemCode === 'Circle') {
					const value = parseFloat(inputValuesForRow[0] || 0)
					quantity = circleShapeQuantity(value)
					isParametr = true
				} else if (service.itemCode === 'SemiCircle') {
					const value = parseFloat(inputValuesForRow[0] || 0)
					quantity = semiCircleShapeQuantity(value)
					isParametr = true
				} else {
					quantity = shapeSidesQuantity(inputValuesForRow)
					isParametr = true
				}
			}

			const inputParametrQuantityValues =
				inputParametrQuantity[
					`${currentRecord.key}${service.itemCode}`
				] || []

			if (inputParametrQuantityValues.length > 0) {
				u_ParametrQuantityValues = inputParametrQuantityValues.reduce(
					(acc, val) => acc + parseFloat(val || 0),
					0,
				)
				isParametr = true
			}

			// Buyoda azgina logika ozgarishi mumkun yani 	service.itemQuantity bunga ham kopaytirish qoshilishi mumkun bu itemmi tashqaridigi tabledigi yozilgan soni ozi postda (+service.quantity * 	+service.u_ParametrQuantityValues * 	service.itemQuantity) bunda service.itemQuantity  ham qoshilgan ekan  ekan
			// Ozi bunda yozilgan O'lcham inputlarini jami bilan *  yozilgan input soniga kopaytilyapti hozir Figuri modaldigi
			const totalPemitr = quantity * u_ParametrQuantityValues

			return {
				...service,
				quantity,
				u_ParametrQuantityValues: u_ParametrQuantityValues,
				totalPemitr: totalPemitr,
				isParametr,
				itemName: service.itemName,
				u_ShapeSides: inputValuesForRow
					.map((val) => val || 0)
					.join(';'),
			}
		})

		// Check if any service has quantity input from any source (quantity field, shape inputs, or parameter quantity)
		// Skip validation for Chizma, Key_Sketches, Rhombic_Sketches, Templete_Figures items as they don't require quantity
		const servicesWithoutQuantity = updatedSelectedServices.filter(
			(service) => {
				// Skip quantity validation for items that don't require quantity
				const noQuantityRequiredItems = [
					'Chizma',
					'Key_Sketches',
					'Rhombic_Sketches',
					"Templete_Figures",
					"ort"
				]
				// Check both u_ItemGroup and u_Modal fields
				if (
					noQuantityRequiredItems.includes(service.u_ItemGroup) ||
					noQuantityRequiredItems.includes(service.u_Modal)
				) {
					return false
				}

				const inputValuesForRow =
					inputValues[`${currentRecord.key}${service.itemCode}`] || []
				const inputParametrQuantityValues =
					inputParametrQuantity[
						`${currentRecord.key}${service.itemCode}`
					] || []

				// Check if quantity comes from any source
				const hasDirectQuantity = service.quantity > 0
				const hasShapeInputs =
					inputValuesForRow.length > 0 &&
					inputValuesForRow.some(
						(val) => parseFloat(val || 0) > 0,
					)
				const hasParametrQuantity =
					inputParametrQuantityValues.length > 0 &&
					inputParametrQuantityValues.some(
						(val) => parseFloat(val || 0) > 0,
					)

				// Service is invalid if it has no inputs from any source
				return !(
					hasDirectQuantity ||
					hasShapeInputs ||
					hasParametrQuantity
				)
			},
		)

		if (servicesWithoutQuantity.length > 0) {
			console.log('servicesWithoutQuantity', servicesWithoutQuantity)
			const invalidServices = servicesWithoutQuantity
				.map((s) => s.itemName)
				.join(', ')
			message.error(
				`Пожалуйста, заполните количество для: ${invalidServices}`,
			)
			return
		}

		// Calculate selectedPrices and shtPrices for services
		const selectedPrices = calculateKvmPrices(updatedSelectedServices)

		const shtPrices = calculateShtPrices(updatedSelectedServices)

		//
		const totalPerimetr = updatedSelectedServices.reduce((acc, service) => {
			return acc + service.totalPemitr
		}, 0)

		const updatedData = tableData.map((row) => {
			if (row.key === currentRecord.key) {
				const koef = 1
				const totalWithKoef = calculateTotalWithKoef(
					row.width,
					row.height,
					row.quantity,
					koef,
				)
				const mWithKoef = calculateMetrTotalWithKoef(
					row.width,
					row.height,
					row.quantity,
					koef,
				)

				const mPrices = updatedSelectedServices.reduce(
					(acc, service) => {
						if (service.ugpName === 'м') {
							return acc + service.price * mWithKoef
						}
						return acc
					},
					0,
				)

				const lineTotal =
					calculateLineTotal(
						row.price,
						selectedPrices,
						totalWithKoef,
					) +
					mPrices +
					shtPrices

				return {
					...row,
					selectedServices: updatedSelectedServices,
					lineTotal,
					totalPerimetr,
				}
			}
			return row
		})

		setTableData(updatedData)
		setSelectedServices(updatedSelectedServices)
		setIsModalOpen(false)
	}

	const handleServiceModalYes = () => {
		setIsConfirmServiceModalVisible(false)
		setIsModalOpen(false)
	}

	const handleServiceModalNo = () => {
		setIsConfirmServiceModalVisible(false)
	}

	const handleServiceModalCancel = () => {
		setIsConfirmServiceModalVisible(false)
	}

	const renderContent = () => {
		switch (activeTab) {
			case 'tab1':
				return (
					<>
						<span className="font-bold text-lg">
							{t('chooseServicesPackage')}
						</span>
						<div className="flex flex-col  gap-1 mt-4 mb-4">
							{packageServicesData.map((service) => (
								<div
									key={service.code}
									className="flex items-center gap-2"
								>
									<span
										className="text-blue-600 hover:text-blue-800 cursor-pointer  font-bold"
										onClick={() =>
											toggleServiceSelectionGroup(
												service.serviceLines,
											)
										}
									>
										{service.name}
									</span>
								</div>
							))}
						</div>
						<Table
							columns={columnsServices}
							dataSource={serviceItemsData?.filter(
								(item) => item.u_Modal === 'Key_Services',
							)}
							rowKey={(record) => record.itemCode}
							onRow={(record) => ({
								onClick: (e) => {
									e.stopPropagation()
									toggleServiceSelection(record?.itemCode)
								},
							})}
							pagination={false}
						/>
					</>
				)

			case 'tab2':
				return (
					<>
						<span className="font-bold text-lg">
							{t('chooseServicesPackage')}
						</span>
						<div className="flex flex-col  gap-1 mt-4 mb-4">
							{packageServicesData.map((service) => (
								<div
									key={service.code}
									className="flex items-center gap-2"
								>
									<span
										className="text-blue-600 hover:text-blue-800 cursor-pointer  font-bold"
										onClick={() =>
											toggleServiceSelectionGroup(
												service.serviceLines,
											)
										}
									>
										{service.name}
									</span>
								</div>
							))}
						</div>

						<Table
							columns={columnsServices}
							dataSource={serviceItemsData?.filter(
								(item) => item.u_Modal === 'Circle_Services',
							)}
							rowKey={(record) => record.itemCode}
							onRow={(record) => ({
								onClick: (e) => {
									e.stopPropagation()
									toggleServiceSelection(record?.itemCode)
								},
							})}
							pagination={false}
						/>
						<div className="flex flex-col gap-2 mt-10">
							<span className="font-bold text-lg mb-5">
								{t('Telefon Burchak')}
							</span>
							<Table
								columns={columnsTelefonParametrs}
								dataSource={telefonItemsData?.sort((a, b) => {
									return a?.itemName.localeCompare(
										b?.itemName,
										'ru',
									)
								})}
								rowKey={(record) => record.itemCode}
								pagination={false}
							/>
						</div>
					</>
				)

			case 'tab3':
				return (
					<>
						<Table
							columns={columnsRombikParametrs}
							dataSource={rombikItemsData}
							rowKey={(record) => record.itemCode}
							pagination={false}
						/>
					</>
				)

			case 'tab4':
				return (
					<>
						<div className="mt-5 flex flex-col gap-5">
							<span className="font-bold text-sm">
								{t('Shablon Xizmatlar')}
							</span>
							<Table
								columns={columnsShablonServices}
								dataSource={serviceItemsData?.filter(
									(item) =>
										item.u_Modal === 'Templete_Services',
								)}
								rowKey={(record) => record.itemCode}
								onRow={(record) => ({
									onClick: (e) => {
										e.stopPropagation()
										toggleShablonServiceSelection(
											record?.itemCode,
										)
									},
								})}
								pagination={false}
							/>
						</div>
						<div className="mt-10 flex flex-col gap-5">
							<span className="font-bold text-sm">
								{t('Shablon Shakllari')}
							</span>
							<Table
								columns={columnsShablonParametrs}
								dataSource={serviceItemsData?.filter(
									(item) =>
										item.u_Modal === 'Templete_Figures',
								)}
								rowKey={(record) => record.itemCode}
								onRow={(record) => ({
									onClick: (e) => {
										e.stopPropagation()

										toggleShablonParametrSelection(
											record?.itemCode,
										)
									},
								})}
								pagination={false}
							/>
						</div>
					</>
				)

			case 'tab5':
				return (
					<>
						<Table
							columns={columnsKalitParametrs}
							dataSource={kalitShapedData}
							rowKey={(record) => record.itemCode}
							onRow={() => ({
								// onClick: (e) => {
								// 	e.stopPropagation()
								// 	toggleKalitParametrSelection(
								// 		record?.itemCode,
								// 		record?.key,
								// 	)
								// },
							})}
							pagination={false}
						/>
					</>
				)

			case 'tab6':
				return (
					<>
						<Table
							columns={columnsItemsImages}
							dataSource={serviceItemsData?.filter(
								(item) => item.u_Modal === 'Rhombic_Sketches',
							)}
							rowKey={(record) => record.itemCode}
							onRow={(record) => ({
								onClick: (e) => {
									e.stopPropagation()
									toggleItemsImagesSelection(record?.itemCode)
								},
							})}
							pagination={false}
						/>
					</>
				)

			case 'tab7':
				return (
					<>
						<Table
							columns={columnsItemsImages}
							dataSource={serviceItemsData?.filter(
								(item) => item.u_Modal === 'Key_Sketches',
							)}
							rowKey={(record) => record.itemCode}
							onRow={(record) => ({
								onClick: (e) => {
									e.stopPropagation()
									toggleItemsImagesSelection(record?.itemCode)
								},
							})}
							pagination={false}
						/>
					</>
				)
			case 'tab8':
				return (
					<>
						<Table
							columns={columnsOtgruzka}
							dataSource={serviceItemsData?.filter(
								(item) => item.u_Modal === 'ort',
							)}
							rowKey={(record) => record.itemCode}
							onRow={(record) => ({
								onClick: (e) => {
									e.stopPropagation()
									toggleServiceSelection(record?.itemCode)
								},
							})}
							pagination={false}
						/>
					</>
				)
			default:
				return null
		}
	}

	return (
		<>
			<Modal
				title={
					<div className="flex items-center gap-2">
						<span className="cursor-pointer text-2xl font-bold">
							{t('services')}
						</span>
					</div>
				}
				open={open}
				onCancel={() => {
					setIsConfirmServiceModalVisible(true)
				}}
				// onOk={handleOkServices}
				footer={null}
				width="65%"
			>
				<div className="w-full">
					<Space style={{ marginBottom: 16 }} className="mt-5 ovew">
						{SERVICE_MODAL_TABS.map((tab, index) => (
							<ServiceModalTabButton
								key={tab.key}
								isActive={activeTab === tab.key}
								marginLeft={index > 0}
								onClick={() => setActiveTab(tab.key)}
							>
								{t(tab.label)}
							</ServiceModalTabButton>
						))}

						{/* <button
							className={`${
								activeTab === 'tab3'
									? 'text-blue-900 underline underline-offset-8'
									: ''
							} font-semibold ml-3`}
							onClick={() => setActiveTab('tab3')}
						>
							{t('shapes')}
						</button>
						<button
							className={`${
								activeTab === 'tab4'
									? 'text-blue-900 underline underline-offset-8'
									: ''
							} font-semibold ml-3`}
							onClick={() => setActiveTab('tab4')}
						>
							{t('chizmalar')}
						</button> */}
					</Space>
					<div className="mt-5">{renderContent()}</div>
					<div className="mt-5 flex items-center justify-end  gap-2">
						<Button
							type="danger"
							className="bg-red-600 text-white hover:bg-red-500"
							onClick={() => {
								setIsConfirmServiceModalVisible(true)
							}}
						>
							{t('cancel')}
						</Button>
						<Button
							type="danger"
							className="bg-blue-800 text-white hover:bg-blue-600"
							onClick={handleOkCombined}
						>
							{t('save')}
						</Button>
					</div>
				</div>
			</Modal>
			<ConfirmExitModal
				visible={isConfirmServiceModalVisible}
				handleClickCancel={handleServiceModalCancel}
				handleClickNo={handleServiceModalNo}
				handleClickYes={handleServiceModalYes}
			/>
		</>
	)
}

export default ServicesModal
